/**
 * iOS requires focus() inside the user gesture that opens a modal.
 * Call primeTickerModalKeyboard() synchronously on tap, then open the modal.
 * TickerInputModal registers the hidden prime input on mount.
 */

let primeInputEl = null;

export function registerTickerModalPrimeInput(element) {
  primeInputEl = element;
}

export function unregisterTickerModalPrimeInput() {
  primeInputEl = null;
}

export function primeTickerModalKeyboard() {
  try {
    primeInputEl?.focus({ preventScroll: true });
  } catch (_) {
    // ignore
  }
}
